module.exports = __webpack_public_path__ + "static/codeaudit_icon-42505b69b1908c07471eb32007ebc5a1.svg";